import React from "react";

// Completed-step check from the Figma "Icons All / Unread" component, drawn on a
// 16px grid and shown at 20px. Colour comes from the parent via currentColor.
const StepCheckIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={20} height={20} viewBox="0 0 16 16" fill="none" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M3 8.33333L6.11111 11.6667L12.3333 5"
      />
    </svg>
  );
};

export default StepCheckIcon;
